import { Contact, CreateContact } from '@/types/contact';
import { Query } from '@/types/query';
import { PaginatedResponse, Response } from '@/types/response';
import { api } from '@/utils/axios';

export const listContacts = async (
  user_id: number,
  query: Query,
): Promise<Response<Contact[] | PaginatedResponse<Contact>>> => {
  const response = await api.get(`/app-web/contacts/${user_id}`, {
    params: query,
  });
  return response.data;
};

export const createContact = async (
  user_id: number,
  contact: CreateContact,
  card_id?: number,
): Promise<Response<Contact>> => {
  const response = await api.post(`/app-web/contacts/${user_id}`, {
    ...contact,
    card_id,
  });
  return response.data;
};

export const getContact = async (
  user_id: number,
  contact_id: number,
): Promise<Response<Contact>> => {
  const response = await api.get(`/app-web/contacts/${user_id}/${contact_id}`);
  return response.data;
};

export const updateContact = async (
  user_id: number,
  contact_id: number,
  contact: CreateContact,
): Promise<Response<Contact>> => {
  const response = await api.put(
    `/app-web/contacts/${user_id}/${contact_id}`,
    contact,
  );
  return response.data;
};

export const deleteContact = async (user_id: number, contact_id: number) => {
  const response = await api.delete(
    `/app-web/contacts/${user_id}/${contact_id}`,
  );
  return response.data;
};

export const testLeadCaptureMail = async (card_id: number, email: string) => {
  const response = await api.post('/app-web/contacts/test-lead-capture-mail', {
    card_id,
    email,
  });
  return response.data;
};
